<ng-container *ngFor="let item of getLabels()">

  <ng-container [ngSwitch]="columns[item].template">
    <ng-container *ngSwitchDefault>
      <div #l (mouseover)="onLabelMouseOver($event, l)" class="label with-tip">
        {{columns[item].caption}}
        <span *ngIf="columns[item].tip" class="tip">
          {{columns[item].tip}}
          </span>
      </div>
    </ng-container>

    <ng-container *ngSwitchCase="'ivx_eod'">
      <ng-container *ngTemplateOutlet="dropdown;context:{
            data: IVX,
            type: 'IVX',
            label: ivxLabel,
            dropDownType: 'Ivx',
            tip: 'Previous Closing IVX'+ivxLabel+'. IVX is the composite measure of the stock\'s implied volatility calculated from an option\'s price using proprietary methodology. See IVolatility knowledge base for more details. IVX'+ivxLabel+' is calculated for the forward '+ivxLabel+' calendar days',
            showTip: showIvxTip}"></ng-container>
    </ng-container>

    <ng-container *ngSwitchCase="'ivx'">
      <ng-container *ngTemplateOutlet="dropdown;context:{
            data: IVX,
            type: 'IVX',
            label: ivxLabel,
            dropDownType: 'Ivx',
            tip: ivxTip + ' implied volatility calculated from an option\'s price using proprietary methodology. See IVolatility knowledge base for more details. IVX'+ivxLabel+' is calculated for the forward '+ivxLabel+' calendar days',
            showTip: showIvxTip}"></ng-container>
    </ng-container>

    <ng-container *ngSwitchCase="'hv'">
      <ng-container *ngTemplateOutlet="dropdown;context:{
            data: HV,
            type: 'HV',
            label: hvLabel,
            dropDownType: 'Hv',
            tip: 'Historical Volatility '+hvLabel+' Days. Actual volatility that occurred to the underlying ' + hvTip + ' during the prior '+hvLabel+' trading days',
            showTip: showHvTip}"></ng-container>
    </ng-container>

    <ng-container *ngSwitchCase="'ivp'">
      <ng-container *ngTemplateOutlet="dropdown;context:{
            data: IVP,
            type: 'IVP',
            label: ivpLabel,
            dropDownType: 'Ivp',
            tip: columns[item].tip,
            showTip: showIvpTip}"></ng-container>
    </ng-container>

    <ng-container *ngSwitchCase="'hvp'">
      <ng-container *ngTemplateOutlet="dropdown;context:{
            data: HVP,
            type: 'HVP',
            label: hvpLabel,
            dropDownType: 'Hvp',
            tip: columns[item].tip,
            showTip: showHvpTip}"></ng-container>
    </ng-container>

    <ng-container *ngSwitchCase="'ivxchange_eod'">
      <div #ll (mouseover)="onLabelMouseOver($event, ll)" class="label with-tip">
        IVX{{ivxLabel}}Chg%
        <span class="tip">
          Previous Day's IVX{{ivxLabel}} Change (%).
          Derived by comparing the previous closing Implied Volatility Index (IVX{{ivxLabel}}) against the day before yesterday's closing value,
          this difference is then expressed as a change in {{currentTab.type === 'instrument' ? ' price' : 'IVX value '}} and a percent change. This value is the total change for the previous day.
        </span>
      </div>
    </ng-container>

    <ng-container *ngSwitchCase="'ivxchange'">
      <div #ll (mouseover)="onLabelMouseOver($event, ll)" class="label with-tip">
        IVX{{ivxLabel}}Chg%
        <span class="tip">
          IVX {{ivxLabel}} Change (%).
          Derived by comparing the current Implied Volatility Index (IVX{{ivxLabel}}) against the previous night's value,
          this difference is then expressed as a change in price and a percent change.
        </span>
      </div>
    </ng-container>

    <ng-container *ngSwitchCase="'ivxchangeopen'">
      <div #ll (mouseover)="onLabelMouseOver($event, ll)" class="label with-tip">
        IVX{{ivxLabel}}ChgO%
        <span class="tip">
          IVX {{ivxLabel}} Change Since Open(%).
          Derived by comparing the current Implied Volatility Index (IVX{{ivxLabel}}) against the most recent opening value
          (9:30AM EST), this difference is then expressed as a change in price and a percent change.
        </span>
      </div>
    </ng-container>

  </ng-container>

  <div [ngSwitch]="columns[item].template" class="value {{columns[item].template}}" style="width: auto;">

    <ng-container *ngSwitchCase="'dividend'">
      <ng-container *ngIf="instrument.stockType == 'I' || instrument.stockType == 'X'">
        {{data.yield * 100 | number}}
      </ng-container>
      <ng-container *ngIf="instrument.stockType !== 'I'&& instrument.stockType !== 'X'">
        {{data.dividendDate | date:'MM/dd/yyyy'}} {{data.dividendAmount | number}}
        <ng-container *ngIf="data.dividendFrequency"><br/>({{getFrequency(data.dividendFrequency)}})</ng-container>
      </ng-container>
    </ng-container>

    <ng-container *ngSwitchDefault>
      {{data[item]| number:'1.0-2' }}
    </ng-container>

    <ng-container *ngSwitchCase="'ivx'">
      <!-- ivx окрашивается как ivxchange -->
      <iv-live-cell [change]="data['ivx'+ivxLabel+'Chg']" [showChangeBackground]="true">
        {{ (data['ivx' + ivxLabel] !== -100) ? data['ivx' + ivxLabel] : ''}}
      </iv-live-cell>
    </ng-container>

    <ng-container *ngSwitchCase="'ivx_eod'">
      <!-- ivx окрашивается как ivxchange -->
      <iv-live-cell [change]="data['ivx'+ivxLabel+'Chg']" [showChangeBackground]="true">
        {{ (data['ivx' + ivxLabel] !== -100) ? data['ivx' + ivxLabel] : ''}}
      </iv-live-cell>
    </ng-container>

    <ng-container *ngSwitchCase="'ivxchange_eod'">
      <iv-live-cell [change]="data['ivx'+ivxLabel+'Chg']" [showChangeValue]="true">
        <span class="material-icons" style="font-size: 18px !important;"></span>
        <span class="with-tip">
                {{data['ivx' + ivxLabel + 'Chg'] | number:'1.0-2'}}
          <span class="tip">
                  Change between the current and previous night’s stock price
                </span>
              </span>
        <span *ngIf="data['ivx'+ivxLabel+'ChgPercent']" class="with-tip">
                ({{data['ivx' + ivxLabel + 'ChgPercent'] | number:'1.0-2' }}%)
                <span class="tip">
                  Percent change between the current and previous night’s stock price
                </span>
              </span>
      </iv-live-cell>
    </ng-container>

    <ng-container *ngSwitchCase="'ivxchange'">
      <iv-live-cell [change]="data['ivx'+ivxLabel+'Chg']" [showChangeValue]="true">
        <span class="material-icons" style="font-size: 18px !important;"></span>
        <span class="with-tip">
                {{data['ivx' + ivxLabel + 'Chg'] | number:'1.0-2'}}
          <span class="tip">
                  Change between the current and previous night’s stock price
                </span>
              </span>
        <span *ngIf="data['ivx'+ivxLabel+'ChgPercent']" class="with-tip">
                ({{data['ivx' + ivxLabel + 'ChgPercent'] | number:'1.0-2' }}%)
                <span class="tip">
                  Percent change between the current and previous night’s stock price
                </span>
              </span>
      </iv-live-cell>
    </ng-container>

    <ng-container *ngSwitchCase="'ivxchangeopen'">
      <iv-live-cell [change]="data['ivx'+ivxLabel+'ChgOpen']" [showChangeValue]="true">
        <span class="material-icons" style="font-size: 18px !important;"></span>
        <span class="with-tip">
                {{data['ivx' + ivxLabel + 'ChgOpen'] | number:'1.0-2'}}
          <span class="tip">
                  Change between the current and opening stock price
                </span>
              </span>
        <span *ngIf="data['ivx'+ivxLabel+'ChgPercentOpen']" class="with-tip">
                ({{data['ivx' + ivxLabel + 'ChgPercentOpen'] | number:'1.0-2' }}%)
                <span class="tip">
                  Percent change between the current and opening stock price
                </span>
              </span>
      </iv-live-cell>
    </ng-container>

    <ng-container *ngSwitchCase="'ivxchangepercent'">
      <!-- price окрашивается как change -->
      <iv-live-cell [change]="data['ivx'+ivxLabel+'ChgPercent']" [showChangeValue]="true">
        {{data['ivx' + ivxLabel + 'ChgPercent']}}
      </iv-live-cell>
    </ng-container>

    <ng-container *ngSwitchCase="'ivxchangepercentopen'">
      <!-- price окрашивается как change -->
      <iv-live-cell [change]="data['ivx'+ivxLabel+'ChgPercentOpen']" [showChangeValue]="true">
        {{data['ivx' + ivxLabel + 'ChgPercentOpen']}}
      </iv-live-cell>
    </ng-container>

    <ng-container *ngSwitchCase="'hv'">
      {{data['hv' + hvLabel]}}
    </ng-container>

    <ng-container *ngSwitchCase="'ivp'">
      {{data['ivp' + ivpLabel]}}
    </ng-container>

    <ng-container *ngSwitchCase="'hvp'">
      {{data['hvp' + hvpLabel]}}
    </ng-container>

    <ng-container *ngSwitchCase="'52whilo'">
      {{data['highPrice52Wk']| number:'1.0-2'}}/{{data['lowPrice52Wk']| number:'1.0-2'}}
    </ng-container>

    <ng-container *ngSwitchCase="'bid'">
      <iv-live-cell [showChangeBackground]="true" [value]="data.bid">
        {{data.bid}}
      </iv-live-cell>
    </ng-container>

    <ng-container *ngSwitchCase="'ask'">
      <iv-live-cell [showChangeBackground]="true" [value]="data.ask">
        {{data.ask}}
      </iv-live-cell>
    </ng-container>

    <ng-container *ngSwitchCase="'bidsize'">
      <iv-live-cell [showChangeBackground]="true" [value]="data.bid">
        {{data.bid}} x {{data.bidSize}}
      </iv-live-cell>
    </ng-container>

    <ng-container *ngSwitchCase="'asksize'">
      <iv-live-cell [showChangeBackground]="true" [value]="data.ask">
        {{data.ask}} x {{data.askSize}}
      </iv-live-cell>
    </ng-container>

    <ng-container *ngSwitchCase="'price'">
      <iv-live-cell *ngIf="data.price" [change]="data.change" [showChangeBackground]="true">
        <span class="currency {{data.currency}}"></span>
        {{data.price}}
      </iv-live-cell>
    </ng-container>

    <ng-container *ngSwitchCase="'so'">
      {{data[item] | so:'1.0-2'}}
    </ng-container>

    <ng-container *ngSwitchCase="'mcap'">
      {{data[item] | so:'1.0-2'}}
    </ng-container>

    <ng-container *ngSwitchCase="'volume'">
      {{data[item] | so:'1.0-2'}}
    </ng-container>

    <ng-container *ngSwitchCase="'change'">
      <iv-live-cell [change]="data.change" [showChangeValue]="true">
        <span class="material-icons" style="font-size: 18px !important;"></span>
        <span class="with-tip">
                {{data.change | number:'1.0-2'}}
          <span class="tip">
                  Change between the current and previous night’s stock price
                </span>
              </span>
        <span *ngIf="data.changePercent" class="with-tip">
                ({{data.changePercent | number }}%)
                <span class="tip">
                  Percent change between the current and previous night’s stock price
                </span>
              </span>
      </iv-live-cell>
    </ng-container>

    <ng-container *ngSwitchCase="'changeopen'">
      <iv-live-cell [change]="data.changeOpen" [showChangeValue]="true">
        <span class="material-icons" style="font-size: 18px !important;"></span>
        <span class="with-tip">
                {{data.changeOpen | number:'1.0-2'}}
          <span class="tip">
                  Change between the current and opening stock price
                </span>
              </span>
        <span *ngIf="data.changePercentOpen" class="with-tip">
                ({{data.changePercentOpen | number }}%)
                <span class="tip">
                  Percent change between the current and opening stock price
                </span>
              </span>
      </iv-live-cell>
    </ng-container>
  </div>
</ng-container>


<ng-template #dropdown let-data="data" let-dropDownType="dropDownType" let-label="label" let-showTip="showTip"
             let-tip="tip"
             let-type="type">
  <div #lll (mouseover)="onLabelMouseOver($event, lll)" [class.with-tip]="showTip" class="label-dropdown label with-tip"
       style="padding-left: 0">
    <iv-live-dropdown
      (openDropdown)="showDropDown(dropDownType, $event)"
      (selectedDataChange)="selectLabel(type, $event)"
      [cssClass]="'hv-select'"
      [data]="data"
      [label]="type + ' '+label"
      [type]="'ivx'"
      [addPercentSuffix]="true"
      style="width: 100%;"
    >
    </iv-live-dropdown>
    <span *ngIf="type==='HV'" class="tip">
Historical Volatility {{label}} Days. Actual volatility that occurred to the underlying {{hvTip}} during the prior {{label}}
      trading days.
    </span>
    <span *ngIf="type!=='HV'" class="tip">
          {{tip}}
    </span>
  </div>
</ng-template>
